export default __webpack_public_path__ + "static/K2Nintex-77059752ae3820b0a0801995507ab1ba.pdf";